import { render, staticRenderFns } from "./orderDialog.vue?vue&type=template&id=3593f1d3&scoped=true"
import script from "./orderDialog.vue?vue&type=script&lang=ts"
export * from "./orderDialog.vue?vue&type=script&lang=ts"
import style0 from "./orderDialog.vue?vue&type=style&index=0&id=3593f1d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3593f1d3",
  null
  
)

export default component.exports